import ProfileApi from '../../api/Survey/Profile';

export const unsubscribeProfile = async (profileId: string) => {
    return await ProfileApi.unsubscribeProfile(profileId);
}

export const updateProfileStatus = async (profileGuid: string) => {
    return await ProfileApi.updateProfileStatus(profileGuid);
}

export const confirmBirthday = async (profileGuid: string, birthday: string) => {
    return await ProfileApi.confirmBirthday(profileGuid, birthday);
}


